import styled, { StyledProps } from 'styled-components/macro';

export type RadioButtonStylesProps = StyledProps<{
  checked: boolean;
  disabled: boolean;
  tabIndex: any;
}>;

const switchBgColor = (props: RadioButtonStylesProps) => {
  if (props.disabled) {
    return '#E6E6E6';
  }

  return props.checked ? '#0EA3F5' : 'rgba(248, 248, 248, 0.3)';
};

const switchBorder = (props: RadioButtonStylesProps) => {
  if (props.disabled) {
    return '1px solid #D1D1D1';
  }
  
  return props.checked ? '1px solid #0EA3F5' : '1px solid #D1D1D1';
};

const switchBoxShadow = (props: RadioButtonStylesProps) => {
  if (props.disabled) {
    return props.checked ? '0 0 0' : 'inset 0px 0.6px 2px rgba(0, 0, 0, 0.25)';
  }
  
  return props.checked ? '0 0 0' : 'inset 0px 0.4px 2px rgba(0, 0, 0, 0.21)';
};

export const RadioButton = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioButtonItem = styled.div`
  width: 16px;
  height: 16px;
  background: ${switchBgColor};
  border: ${switchBorder};
  box-sizing: border-box;
  box-shadow: ${switchBoxShadow};
  border-radius: 50%;
  cursor: pointer;
  transition: .2s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.disabled ? '#BCBCBC' : '#fff'};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  position: relative;

  &:focus {
    outline: none;
  }

  &:hover {
    outline: none;
    border: ${props => props.checked ? '1px solid #0097EB' : '1px solid #D1D1D1'};

    &:before {
      background: ${props => props.checked ? '#fff' : '#2DADF7'};
      opacity: ${props => props.checked ? '1' : '.4'};
      box-shadow: ${props => props.checked ? '0px 0.6px 1px #007DA0' : '0 0 0'};
    }
  }

  &:before {
    content: '';
    width: 7px;
    height: 7px;
    background: ${props => props.disabled ? '#BCBCBC' : '#fff'};
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: ${props => props.disabled ? '0 0 0' : '0px 0.6px 1px #007DA0'};
    opacity: ${props => props.checked ? '1' : '0'};
    transition: .2s;
  }
`;

export const Label = styled.div`
  font-size: 12px;
  color: #1D1E25;
  margin-left: 5px;
  margin-right: 10px;
  cursor: pointer;
`;